

import { privacyModeTextFormatterMixin } from '@/mixins';
import FormatterService from "@/service/FormatterService";

export default {
    name: "TooltipPopupPerformance",

    mixins: [ privacyModeTextFormatterMixin, ],

    props: {
        portfolioId: String,
        isGain: Boolean,
    },

    data() {
        return {
            isVisible: false,
            item: null,
            headerValue: null,
            format: new FormatterService({
                currency: 'EUR'
            }),
        }
    },

    beforeMount() {
        this.$root.$on("request-open-performance-tooltip-popup", this.openWindow);
        window.addEventListener('keydown', this.onKeyDown)
    },

    beforeUnmount() {
        this.$root.$off("request-open-performance-tooltip-popup", this.openWindow);
        window.removeEventListener('keydown', this.onKeyDown)
    },

    methods: {
        openWindow(item, headerValue) {
            this.item = item
            this.headerValue = headerValue
            this.isVisible = true;
        },
        closeWindow() {
            this.isVisible = false;
        },
        onKeyDown(e) {
            if (e.key === 'Escape') this.closeWindow();
            if (e.key === 'Enter' && this.isVisible) {
                this.closeWindow()
            }
        },
        getTextClass(value) {
            return this.format.getChangeClass(value)
        }
    }
}
